import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData,
  type GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostError,
  type GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponse,
  generatePromptsForImageV1ImagesImageIdGeneratePromptsPost,
} from '../../generated';

export type GeneratePromptsForImageMutationVariables =
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData['path'];

export type GeneratePromptsForImageMutation = GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponse;

export const useGeneratePromptsForImageMutation = <
  TError = GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<GeneratePromptsForImageMutation, TError, GeneratePromptsForImageMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<GeneratePromptsForImageMutation, TError, GeneratePromptsForImageMutationVariables, TContext>({
    mutationKey: ['GeneratePromptsForImage'],
    mutationFn: async ({ image_id }: GeneratePromptsForImageMutationVariables) => {
      const { data } = await generatePromptsForImageV1ImagesImageIdGeneratePromptsPost({
        path: { image_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGeneratePromptsForImageMutation.fetcher = (
  { image_id }: GeneratePromptsForImageMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await generatePromptsForImageV1ImagesImageIdGeneratePromptsPost({
      path: { image_id },
      throwOnError: true,
    });
    return data;
  };
};
